import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const reviews = [{
  text: 'Das Futtertopping Magen & Darm ist echt richtig gut. Unser Golden Retriever frisst kein Gras mehr. Ben ist viel besser drauf was die Verdauung betrifft.',
  author: 'Familie Berger & Ben'
}, {
  text: 'Mein Hund hat sich schnell an das Topping gewöhnt und nach ca. 1 Woche hat sich sein Stuhl verbessert. Ich bin super zufrieden.',
  author: 'Sandra aus Berlin'
}, {
  text: 'Nala hat das Futtertopping sehr gut vertragen – gerne bestelle ich es wieder. Klasse!',
  author: 'Petra aus Köln'
}];
export function Testimonials() {
  return <section className="w-full py-16 px-4 bg-white/40" data-id="element-114">
      <div className="max-w-5xl mx-auto" data-id="element-115">
        <h2 className="font-handwriting text-4xl text-center text-forest font-bold mb-10" data-id="element-116">
          Erfahrungen anderer Hundeeltern
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-117">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-cream-card p-6 rounded-xl shadow-sm border border-brown/10 flex flex-col" data-id="element-118">
              <div className="flex gap-1 mb-4 text-yellow-500" data-id="element-119">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-120" />)}
              </div>
              <p className="font-serif text-gray-700 mb-6 flex-grow italic" data-id="element-121">
                "{review.text}"
              </p>
              <p className="font-handwriting text-xl text-forest font-bold" data-id="element-122">
                – {review.author}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}